<template>
  <div class="overlay" v-if="IsSuccessful">
    <div class="dealer-submit-box">
    <h3>{{ SubmitDealerName }} has been {{ IsMode }} successfully!</h3>
    <button class="dealer-submit-confirm-btn" @click="handleConfirm">OK</button>
    </div>
  </div>
  <div class="dealer-comp-cont">
    <h1>Dealer Editor</h1>
    <div class="dealer-table-page">
      <DealerTable style="width: 100%;" />
      <div class="dealer-comp-form-headers">
        <div class="dealer-comp-form-head" v-if="Mode === 'edit'">Edit Dealer</div>
        <div class="dealer-comp-form-head" v-else>Add Dealer</div>
        <DealerForm :dataInputs="DealerInputs" />
      </div>
    </div>
  </div>
</template>

<script>
import { useDealerStore } from '@/store/DealerStore';
import DealerTable from './DealerTable.vue';
import DealerForm from './DealerForm.vue';

export default {
  components: {
    DealerForm,
    DealerTable
  },
  computed: {
    IsSuccessful () {
      return useDealerStore().isSuccessful;
    },
    SubmitDealerName () {
      return useDealerStore().submitDealerName;
    },
    Dealers () {
      return useDealerStore().dealers;
    },
    Mode () {
      return useDealerStore().Mode;
    },
    DealerInputs () {
      const dealerStore = useDealerStore();
      if (this.Mode === 'edit') {
        return dealerStore.EditDealerInputs;
      } else {
        return dealerStore.CreateDealerInputs;
      }
    },
    IsMode () {
      return useDealerStore().isMode;
    }
  },
  methods: {
    handleConfirm () {
      useDealerStore().isMode = 'default';
      useDealerStore().isSuccessful = false;
    }
  }
};
</script>

<style scoped>
.dealer-comp-cont {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.dealer-table-add-btn {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100px;
  cursor: pointer;
}
.dealer-table-add-btn-icon {
  width: 20px;
}
td {
  text-align: center;
}
.dealer-table-page {
  display: flex;
  flex-wrap: row;
  justify-content: center;
  gap: 10px;
  width: 100%;
}
.dealer-comp-form-headers {
  width: 40%;
  max-height: 90vh;
  overflow-y: auto;
}
.dealer-comp-form-head {
  text-align: center;
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 10px;
}
.overlay {
          position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex; /* Flexbox for centering */
        justify-content: center;
        align-items: flex-start;
        padding-top: 20px;
        backdrop-filter: #7f7f7f; /* Blur everything behind */
        background-color: rgba(0, 0, 0, 0.3); /* Optional dark tint */
        z-index: 99999999; /* Ensure it’s on top */
}
.dealer-submit-box {
         background: white;
        padding: 20px 40px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
        text-align: center;
        max-width: 400px
}
.dealer-submit-confirm-btn {
  cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    color: #FFFFFF;
    padding: 5px;
    width: 70px;
    text-align: center;
    margin-top: 10px;
    background-color: var(--nelson-green);
}
</style>